import * as Yup from "yup";

export const dataModel = {
  code: "",
  name: "",
  namePt: "",
  performance: null,
  culture: "",
  active: false,
  description: "",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      code: Yup.string().required("forms.validations.required"),
      name: Yup.string().required("forms.validations.required"),
      namePt: Yup.string().required("forms.validations.required"),
      performance: Yup.number().required("forms.validations.required"),
      culture: Yup.string().required("forms.validations.required"),
      active: Yup.boolean().required("forms.validations.required"),
      description: Yup.string().optional(""),
    });
  }

  return Yup.object().shape({
    code: Yup.string().required("forms.validations.required"),
    name: Yup.string().required("forms.validations.required"),
    performance: Yup.number().required("forms.validations.required"),
    culture: Yup.string().required("forms.validations.required"),
    active: Yup.boolean().required("forms.validations.required"),
    description: Yup.string().optional(""),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
